export default __webpack_public_path__ + "static/media/photo--sm--107.9bc2e8e8.jpg";